// Module
var code = "<a href=\"#\" class=\"product-item\"> <figure class=\"thumbnail\"> <img src=\"#\"> <figcaption></figcaption> </figure> <div class=\"user-profile\"> <img src=\"#\"> <p class=\"name\"></p> </div> </a>";
// Exports
module.exports = code;